import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../base-component'

const BUTTON_SELECTOR = '[data-cart-sticky-button]'
const HEADER_SELECTOR = '.shopify-section.shopify-section-header'

export class StickyCartButton extends BaseComponent {
  mountComponent(): void {
    this.addListener(window, 'scroll', this.handleWindowScroll)
  }

  handleWindowScroll = (): void => {
    const header = $el(HEADER_SELECTOR)
    const button = $el(BUTTON_SELECTOR, this)

    if (header && button) {
      const rect = header.getBoundingClientRect()
      button.classList.toggle(
        'is-visible',
        rect.bottom + button.offsetHeight < 0,
      )
    }
  }
}
